"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "RecaptchaErrorModal", {
  enumerable: true,
  get: function () {
    return _RecaptchaErrorModal.default;
  }
});
_Object$defineProperty(exports, "RecaptchaModal", {
  enumerable: true,
  get: function () {
    return _RecaptchaModal.default;
  }
});
var _RecaptchaModal = _interopRequireDefault(require("./RecaptchaModal"));
var _RecaptchaErrorModal = _interopRequireDefault(require("./RecaptchaErrorModal"));